module.exports = __webpack_public_path__ + "img/Question-bg-8.d38c1d3e.png";